import { render } from "./ListParticipantsView.vue?vue&type=template&id=624216d7"
import script from "./ListParticipantsView.vue?vue&type=script&lang=js"
export * from "./ListParticipantsView.vue?vue&type=script&lang=js"

import "./ListParticipantsView.vue?vue&type=style&index=0&id=624216d7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__